<div class="main-input-filter" [ngClass]="{ 'has-text': searchText !== '' }">
  <div class="search-wrapper">
    <span class="search-icon"></span>
    <div class="input-container">
      <input
        id="search"
        role="search"
        aria-label="Buscar noticias"
        class="sl-input-textbox"
        [(ngModel)]="searchText"
        (ngModelChange)="changeValue()"
        autocomplete="off"
        placeholder=" "
      />
      <label for="search" class="floating-label">Buscar</label>
    </div>
    @if(searchText !== '') {
    <sl-button
      id="sl-search-clear-button"
      type="icon-only"
      variant="tertiary"
      iconName="close"
      size="small"
      (clickEvent)="clearSearch()"
      class="clear-btn"
    ></sl-button>
    }
  </div>
</div>
